import { createContext, Dispatch, SetStateAction } from 'react';

/**
 * Transient credentials captured during the login / password-reset
 * flow that are needed to complete MFA enrollment.
 *
 * SECURITY NOTE:
 *   These values are held in memory only (plain React state) and are
 *   intentionally NOT persisted to sessionStorage, localStorage, cookies,
 *   or any URL (path params, query string, hash). They must be cleared
 *   as soon as the MFA setup flow completes or is abandoned so they do
 *   not linger in memory longer than necessary.
 */
export interface MFASetupCredentials {
  username: string;
  password: string;
}

export const EMPTY_MFA_SETUP_CREDENTIALS: MFASetupCredentials = {
  username: '',
  password: ''
};

export interface MFASetupProvider {
  credentials: MFASetupCredentials;
  setCredentials: Dispatch<SetStateAction<MFASetupCredentials>>;
  clearCredentials: () => void;
}

export const MFASetupContext = createContext<MFASetupProvider>({
  credentials: EMPTY_MFA_SETUP_CREDENTIALS,
  setCredentials: () => {
    throw new Error('MFASetupContext.setCredentials not implemented');
  },
  clearCredentials: () => {
    throw new Error('MFASetupContext.clearCredentials not implemented');
  }
});
